import {observable} from 'mobx';

export class ChangePasswordState {
    @observable waiting: boolean = false;

    @observable message: string = '';
}
